var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSuccessV2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.867 11.4021V12.3221C21.8658 14.4786 21.1675 16.5768 19.8763 18.304C18.5852 20.0311 16.7703 21.2946 14.7024 21.906C12.6344 22.5175 10.4243 22.444 8.40147 21.6967C6.37869 20.9494 4.65166 19.5682 3.47796 17.7592C2.30427 15.9502 1.7468 13.8102 1.88868 11.6584C2.03057 9.50669 2.86421 7.45846 4.26528 5.8192C5.66636 4.17995 7.55979 3.03751 9.66319 2.56228C11.7666 2.08704 13.9673 2.30447 15.937 3.18213",
    stroke: "#65A100",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.867 4.32227L11.867 14.3323L8.867 11.3323",
    stroke: "#65A100",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessV2);
export default __webpack_public_path__ + "static/media/Success-v2.bdfbcb14.svg";
export { ForwardRef as ReactComponent };